/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeletePersonEmailInput = {
    personId: number;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deletePersonEmailMutationVariables = {
    input: DeletePersonEmailInput;
};
export type deletePersonEmailMutationResponse = {
    readonly DeletePersonEmail: {
        readonly MissionControlPersonList: {
            readonly id: string;
            readonly personId: number | null;
            readonly companyId: number | null;
            readonly companyName: string | null;
            readonly accountPlan: string | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly email: string | null;
            readonly active: boolean | null;
        } | null;
    } | null;
};
export type deletePersonEmailMutation = {
    readonly response: deletePersonEmailMutationResponse;
    readonly variables: deletePersonEmailMutationVariables;
};



/*
mutation deletePersonEmailMutation(
  $input: DeletePersonEmailInput!
) {
  DeletePersonEmail(input: $input) {
    MissionControlPersonList {
      id
      personId
      companyId
      companyName
      accountPlan
      firstName
      lastName
      email
      active
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePersonEmailInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePersonEmailPayload",
    "kind": "LinkedField",
    "name": "DeletePersonEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlPersonListType",
        "kind": "LinkedField",
        "name": "MissionControlPersonList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "personId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountPlan",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deletePersonEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deletePersonEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deletePersonEmailMutation",
    "operationKind": "mutation",
    "text": "mutation deletePersonEmailMutation(\n  $input: DeletePersonEmailInput!\n) {\n  DeletePersonEmail(input: $input) {\n    MissionControlPersonList {\n      id\n      personId\n      companyId\n      companyName\n      accountPlan\n      firstName\n      lastName\n      email\n      active\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f931512391b09e6704985747c7fdb0b1';
export default node;
